import { queryOptions, useQuery } from '@tanstack/react-query';

import type { Invoice } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { findDataInQueryCache } from '../utils';
import { invoiceSchema } from './schemas';

export const invoiceQueryOptions = (id: number | null) => {
  const cachedInvoice = findDataInQueryCache<Invoice>([...QueryKeys.invoices.index.root, 'metadata'], (invoice) => invoice.id === id);

  return queryOptions({
    queryKey: QueryKeys.invoices.show.id(id ?? 0),
    queryFn: async () => {
      const { data: invoice } = await fetchJson(`/invoices/${id}`, {
        schema: apiResourceSchema(invoiceSchema),
      });

      return invoice;
    },
    initialData: cachedInvoice?.data,
    initialDataUpdatedAt: cachedInvoice?.state.dataUpdatedAt,
    staleTime: 60 * 1000,
    enabled: id !== null,
  });
};

export const useInvoice = (id: number | null) => {
  return useQuery(invoiceQueryOptions(id));
};
